<template>
  <div v-if="hasLoggedIn">
    <b-navbar v-if="refreshDom" toggleable="lg" type="light" variant="light" class="page-wrapper">
      <b-navbar-brand :to="'/home'">
        <b-img v-if="refreshDom" width="90" height="60" :src="homeLogo.location" rounded></b-img>
      </b-navbar-brand>
      <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>
      <b-collapse id="nav-collapse" is-nav>
        <div id="next-break-total">
          <div v-if="showClassCountdown">
            <div id="next-break-subtotal">
              <div id="next-break-label">
                <label id="next-break">{{ $t('AppLayout.nextBreak') }}</label>
              </div>
              <div id="next-break-countdown">
                <count-down
                  class="app-layout-time"
                  id="class-count-down"
                  v-on:start_callback="countClassStart()"
                  v-on:end_callback="countClassEnd()"
                  :currentTime="currentTime"
                  :startTime="classTime"
                  :endTime="classEndTime"
                  hourTxt
                  :minutesTxt="$t('AppLayout.minute')"
                  :secondsTxt="$t('AppLayout.second')"
                ></count-down>
              </div>
            </div>
          </div>
          <div v-else>{{ $t('AppLayout.notCountdown')}}</div>
        </div>
        <div id="personal-info">
          <b-img
            id="avator"
            :src="avatar"
            v-bind="avatorProps"
            rounded="circle"
            blank-color="#ff6699"
          ></b-img>
          <label id="name">{{ userName }}</label>
          <b-button
            id="logout"
            pill
            variant="outline-secondary"
            size="sm"
            @click="logout"
          >{{ $t('AppLayout.logout') }}</b-button>
        </div>
        <b-navbar-nav class="ml-auto" v-show="t">
          <b-nav-item-dropdown right v-show="f">
            <template v-slot:button-content>
              <em>{{ user.name }}</em>
            </template>
            <b-dropdown-item @click="profile">{{ $t('AppLayout.profile') }}</b-dropdown-item>
            <b-dropdown-item @click="logout">{{ $t('AppLayout.logout') }}</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
      <b-modal
        id="restDialog"
        :title="$t('AppLayout.restTitle')"
        centered
        hide-footer
        hide-header-close
        no-stacking
        no-close-on-backdrop
        no-close-on-esc
        hide-backdrop
        v-model="showRestDialog"
        @ok="onDialogClose"
      >
        <p class="my-4">{{ restDialogContent }}</p>
        <count-down
          class="rest-dialog-time"
          id="break-count-down"
          v-if="showBreakCountdown"
          v-on:start_callback="countBreakStart()"
          v-on:end_callback="countBreakEnd()"
          :currentTime="currentTime"
          :startTime="breakTime"
          :endTime="breakEndTime"
          hourTxt
          :minutesTxt="$t('AppLayout.minute')"
          :secondsTxt="$t('AppLayout.second')"
        ></count-down>
        <b-button
          v-if="buttonEnabled"
          id="restDialogButton"
          block
          variant="success"
          @click="onDialogClose"
        >{{ $t('AppLayout.continueStudy')}}</b-button>
      </b-modal>
    </b-navbar>
  </div>
</template>

<script lang='js'>
import Vue from 'vue'
import { mapState, mapGetters } from 'vuex'
import CountDown from './vue2-countdown'

const TopNavBar = Vue.extend({
  name: 'TopNavBar',
  data: function () {
    return {
      avatar: require('../../assets/EditPersonalInfo/wo.png'),
      avatorProps: { blank: false, width: 45, height: 45, class: 'm1' },
      t: true,
      f: false,
      logoutInterval: 3600000,
      refresh: null,
      dialog: null,
      classInterval: 30 * 60 * 1000,
      breakInterval: 5 * 1000,
      classTime: 0,
      classEndTime: 0 + this.classInterval,
      breakTime: 0,
      breakEndTime: 0 + this.breakInterval,
      currentTime: 0,
      showClassCountdown: false,
      showBreakCountdown: false,
      showRestDialog: false,
      restDialogCancel: false,
      restDialogContent: '',
      buttonEnabled: false,
      userName: localStorage.name,
      showLayout: true
    }
  },
  components: {
    CountDown
  },
  computed: {
    ...mapState({
      user: state => state.auth.currentUser,
      file: state => state.resource.file,
      status: state => state.resource.status
    }),
    ...mapGetters({
      haveLoginInfo: 'auth/isLogin',
      isFileChange: 'resource/size',
      homeLogo: 'resource/homeLogo'
    }),
    stateAvatar () {
      return this.user.avatar
    },
    hasLoggedIn () {
      return this.$store.getters['auth/isLogin']
    },
    refreshDom () {
      if (this.$route.path.indexOf('/login') > -1 || this.$route.path.indexOf('fullfillInfo') > -1 ||
       this.$route.path.indexOf('/forgetNumber') > -1 || this.$route.path.indexOf('/contactUs') > -1 ||
       this.$route.path.indexOf('/forgetPassword') > -1) {
        return false
      } else {
        return true
      }
    }
  },
  watch: {
    $route (to, from) {
      this.userName = this.user.name
      if (this.$route.path.indexOf('typingEssay') > -1) {
        this.noClassOrBreak()
      } else {
        this.refreshNewClass()
      }
      if (this.$route.path.indexOf('/login') > -1 || this.$route.path.indexOf('fullfillInfo') > -1 ||
       this.$route.path.indexOf('/forgetNumber') > -1 || this.$route.path.indexOf('/contactUs') > -1 ||
       this.$route.path.indexOf('/forgetPassword') > -1) {
        this.$nextTick(() => {
          this.showLayout = false
        })
      } else {
        this.showLayout = true
        // if (!this.$store.state.resource.status[this.fileId]) {
        //   this.$store.dispatch('resource/getFileType', this.fileId)
        // }
      }
    },
    stateAvatar () {
      if (this.$route.path !== '/userProfile') {
        this.avatar = localStorage.avatar
      }
    }
  },
  mounted () {
    if (localStorage.startStudy === 'true') {
      this.classStart(parseInt(localStorage.classTime))
    }
    if (localStorage.startBreak === 'true') {
      this.breakStart(parseInt(localStorage.classTime))
    }
    if (this.user.avatar === null) {
      if (this.$route.path.includes('/home') && this.$route.path.includes('/login')) {
        this.$store.dispatch('auth/getAvatar')
      }
    }
    if (this.$route.path === '/login') {
      this.$nextTick(() => {
        this.showLayout = false
      })
    } else {
      this.$nextTick(() => {
        this.showLayout = true
      })
    }
    this.refreshNewClass()
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/userLogout')
        .then(() => {
          localStorage.removeItem('token')
          this.$router.replace('login')
        })
    },
    profile () {
      this.$router.push({
        name: 'userProfile'
      })
    },
    countClassStart () {
    },
    countClassEnd () {
      this.breakStart(new Date().getTime())
    },
    countBreakStart () {
    },
    countBreakEnd () {
      localStorage.startStudy = false
      localStorage.startBreak = false
      this.restDialogContent = this.$t('AppLayout.restDialogContentTimeUp')
      this.buttonEnabled = true
    },
    onDialogClose () {
      this.showRestDialog = false
      this.$store.dispatch('auth/refreshToken')
      this.refreshNewClass()
    },
    classStart (classStartTime) {
      localStorage.startBreak = false
      localStorage.startStudy = true
      localStorage.classTime = classStartTime
      this.$store.dispatch('studyOrBreak/setBreak', { status: false })
      this.classTime = parseInt(localStorage.classTime)
      this.classEndTime = this.classTime + this.classInterval
      this.currentTime = new Date().getTime()
      this.showClassCountdown = true
    },
    noClassOrBreak () {
      localStorage.startStudy = false
      localStorage.startBreak = false
      this.showClassCountdown = false
      this.showRestDialog = false
    },
    breakStart (breakStartTime) {
      localStorage.startStudy = false
      localStorage.startBreak = true
      localStorage.breakTime = breakStartTime
      this.$store.dispatch('studyOrBreak/setBreak', { status: true })
      this.showRestDialog = true
      this.breakTime = parseInt(localStorage.breakTime)
      this.breakEndTime = this.breakTime + this.breakInterval
      this.currentTime = this.breakTime
      this.showClassCountdown = false
      this.showBreakCountdown = true
      this.restDialogContent = this.$t('AppLayout.restDialogContent')
      this.buttonEnabled = false
    },
    refreshNewClass () {
      if (this.$route.path.indexOf('typing') > -1 || this.$route.path.indexOf('wordPractice') > -1) {
        if (localStorage.startBreak === 'false' && localStorage.startStudy === 'false') {
          this.classStart(new Date().getTime())
        } else if (localStorage.startBreak === 'true' && localStorage.startStudy === 'false') {
          this.breakStart(localStorage.breakTime)
        } else if (localStorage.startBreak === 'false' && localStorage.startStudy === 'true') {
          this.classStart(localStorage.classTime)
        }
      } else {
        if (localStorage.startBreak === 'false' && localStorage.startStudy === 'false') {
          this.noClassOrBreak()
        } else if (localStorage.startBreak === 'true' && localStorage.startStudy === 'false') {
          this.breakStart(localStorage.breakTime)
        } else if (localStorage.startBreak === 'false' && localStorage.startStudy === 'true') {
          this.classStart(localStorage.classTime)
        }
      }
    }
  }
})
export default TopNavBar
</script>

<style lang='scss' scoped>
.brand-name-style {
  font-size: 30px;
  font-weight: bolder;
}
.nav-item-style {
  font-size: 18px;
  font-weight: bold;
}
.rest-dialog-time {
  text-align: center;
  letter-spacing: 3px;
  font-style: normal;
  font-size: 28px;
  font-weight: bold;
}
.app-layout-time {
  text-align: center;
  font-style: normal;
  font-size: 23px;
  font-weight: bold;
}
#next-break-total {
  width: auto;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -40%);
}
#next-break {
  font-size: 16px;
}
#next-break-label {
  display: inline-block;
  position: relative;
  bottom: 0;
  left: 0;
}
#next-break-countdown {
  display: inline-block;
  position: relative;
  bottom: 0;
  right: 0;
}
#next-break-subtotal {
  display: inline-block;
  position: relative;
  width: 220px;
}
#personal-info {
  position: absolute;
  right: 2%;
}
#avator {
  margin-top: 0;
  margin-bottom: 0;
}
#name {
  margin-left: 15px;
}
#logout {
  width: 80px;
  margin-left: 20px;
}

@media screen and (min-width: 1024px) {
  .fixed-width-page {
    margin-left: calc(100vw - 100%);
  }
}
</style>
